import { useAppContext } from "../../AppProvider";
import { getParcelsHeaderGridLayout } from "./Layout";
import { createParcelsHeaderGridVars } from "./Layout/gridVars";

export const ParcelHeader = () => {
  const { dictionary, display } = useAppContext();

  const parcelsHeaderLayout = getParcelsHeaderGridLayout();
  const parcelsHeaderStyle = createParcelsHeaderGridVars(parcelsHeaderLayout);

  return (
    <>
      {(display.lg || display.xl || display.xxl) && (
        <>
          <div
            data-grid-template="parcelsHeader"
            className="d-grid gap-2 p-2"
            style={parcelsHeaderStyle}
          >
            <div data-grid-area="internalReference">
              <label className="label-2">
                {dictionary.references.internal_reference}
              </label>
            </div>
            <div data-grid-area="width">
              <label className="label-2">
                {dictionary.dimensions.width} (cm)
              </label>
            </div>
            <div data-grid-area="length">
              <label className="label-2">
                {dictionary.dimensions.length} (cm)
              </label>
            </div>
            <div data-grid-area="height">
              <label className="label-2">
                {dictionary.dimensions.height} (cm)
              </label>
            </div>
            <div data-grid-area="weight">
              <label className="label-2">
                {dictionary.dimensions.weight} (Kg)
              </label>
            </div>
            <div data-grid-area="volume">
              <label className="label-2">
                {dictionary.dimensions.volume} (m<sup>3</sup>)
              </label>
            </div>
          </div>
        </>
      )}
    </>
  );
};
